export default "__VITE_ASSET__BnK$_ELL__"